import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import { TopSitesTableWidgetFilters } from "../widget-filters/TopSitesTableWidgetFilters";
import { TableWidget } from "./TableWidget";

export class DashboardTopSitesTableWidget extends TableWidget {
    static getWidgetMetadataType() {
        return "TopSitesTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getWidgetDashboardType() {
        return "Table";
    }

    static getFiltersComponent() {
        return TopSitesTableWidgetFilters;
    }

    constructor() {
        super();
    }

    public getSearchKey() {
        return "Domain";
    }

    public getWidgetFilters() {
        return {
            filter: this.apiParams.filter,
        };
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }
}

DashboardTopSitesTableWidget.register();
